// @flow
import type { ContactType } from '@gandi/redux-resource-contactbook';
import { useTranslator } from '@gandi/translate';

const types = ['individual', 'publicbody', 'association', 'company'] as const;

export function useType(type?: ContactType): string | null {
  const { __ } = useTranslator();

  if (!type) return null;

  const names = {
    individual: __('Individual'),
    publicbody: __('Public Body'),
    association: __('Association'),
    company: __('Company'),
  };

  return names[type] || names[types[parseInt(type, 10)]];
}

type EntityType = 'organization' | 'user' | 'resellee';
export function useEntityType(entityType?: EntityType): string | null {
  const { __ } = useTranslator();

  if (!entityType) return null;

  const labels = {
    organization: __('Organization'),
    user: __('User'),
    resellee: __('Customer'),
  };

  return labels[entityType] || entityType;
}
